import { MsisdnNotificationsInterfaceState, initialMsisdnNotificationsState } from '../state/msisdn-notifications.state';
import { CustomerMsisdnNotificationsActions, ECustomerMsisdnNotificationsActions } from '../actions/customer-msisdn-notifications.actions';

export function customerMsisdnNotificationsReducer(state: MsisdnNotificationsInterfaceState = initialMsisdnNotificationsState, action: CustomerMsisdnNotificationsActions): MsisdnNotificationsInterfaceState {
  switch (action.type) {
    case ECustomerMsisdnNotificationsActions.GetCustomerMsisdnNotificationsSuccess: {
      return { ...state, result: action.payload };
    }

    default:
      return initialMsisdnNotificationsState;
  }
};
